module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah M. Anderson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sarah M. Anderson won RT Reviewer's Choice 2012 Desire of the Year for "), _c('I', [_vm._v("A Man of Privilege")]), _vm._v(". "), _c('I', [_vm._v("The Nanny Plan")]), _vm._v(" was a 2016 RITA® winner for Contemporary Romance: Short. Find out more about Sarah's love of cowboys at www.sarahmanderson.com")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17LXdNQ/tc-custom/9781460338711.jpg?1737195674752",
      "alt": "This image is the cover for the book Not the Boss's Baby, The Beaumont Heirs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Not the Boss's Baby, The Beaumont Heirs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Pregnant and single, a secretary falls for her billionaire boss in this sexy romance from an award-winning author.")]), _c('br'), _c('br'), _c('i', [_vm._v("What the boss wants . . . ")]), _c('br'), _c('br'), _vm._v("As the oldest son, Chadwick Beaumont has sacrificed everything for the Beaumont family business, but he swore he’d never follow in his father’s philandering footsteps. For years, he’s dutifully kept his distance from the temptation outside his office door—his beautiful secretary Serena Chase."), _c('br'), _c('br'), _vm._v("But now everything has changed. His family’s company is in jeopardy. His personal life is in shambles. And his sexy assistant is suddenly single . . . and flirting. Chadwick is tired of doing what’s expected. It’s time for him to go after what he wants. And what he wants is Serena—even if she’s expecting another man’s child.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0